 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		4: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		4: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"styles","2":"0f1ac474","3":"5b74f8667f3a7f27ab8185c7fc08a7f63be63316","6":"component---src-pages-404-js","7":"component---src-pages-contact-index-js","8":"component---src-pages-day-camp-christmas-day-camp-js","9":"component---src-pages-day-camp-march-break-day-camp-js","10":"component---src-pages-day-camp-pd-pa-day-camp-js","11":"component---src-pages-events-1980-s-staff-reunion-js","12":"component---src-pages-events-christmas-at-the-ranch-js","13":"component---src-pages-events-easter-roundup-js","14":"component---src-pages-events-family-day-roundup-js","15":"component---src-pages-events-family-winter-activity-adventure-js","16":"component---src-pages-events-march-break-camp-for-a-weekend-js","17":"component---src-pages-events-teen-ranch-fall-gallop-a-cross-country-run-js","18":"component---src-pages-events-the-christmas-winter-festival-js","19":"component---src-pages-facilities-js","20":"component---src-pages-families-family-getaway-weekends-js","21":"component---src-pages-families-father-son-hockey-weekend-js","22":"component---src-pages-families-js","23":"component---src-pages-families-mother-daughter-equine-escape-js","24":"component---src-pages-give-index-js","25":"component---src-pages-in-memory-of-mel-stevens-js","26":"component---src-pages-index-js","27":"component---src-pages-outdoor-education-js","28":"component---src-pages-programs-hockey-and-skating-3-on-3-hockey-league-js","29":"component---src-pages-programs-hockey-and-skating-adult-hockey-skills-js","30":"component---src-pages-programs-hockey-and-skating-afternoon-summer-skills-clinics-js","31":"component---src-pages-programs-hockey-and-skating-goalie-clinic-js","32":"component---src-pages-programs-hockey-and-skating-ice-rental-js","33":"component---src-pages-programs-hockey-and-skating-index-js","34":"component---src-pages-programs-hockey-and-skating-learn-to-skate-js","35":"component---src-pages-programs-hockey-and-skating-mens-hockey-league-js","36":"component---src-pages-programs-hockey-and-skating-private-lessons-js","37":"component---src-pages-programs-hockey-and-skating-public-skating-js","38":"component---src-pages-programs-hockey-and-skating-skills-and-skating-development-js","39":"component---src-pages-programs-hockey-and-skating-spring-hockey-league-js","40":"component---src-pages-programs-hockey-and-skating-starskate-and-competitive-figure-skating-js","41":"component---src-pages-programs-hockey-and-skating-wranglers-hockey-js","42":"component---src-pages-programs-horses-hunter-jumper-shows-index-js","43":"component---src-pages-programs-horses-hunter-jumper-shows-show-photos-js","44":"component---src-pages-programs-horses-index-js","45":"component---src-pages-programs-horses-schooling-ring-rental-js","46":"component---src-pages-programs-horses-trail-rides-js","47":"component---src-pages-programs-index-js","48":"component---src-pages-retreats-index-js","49":"component---src-pages-staff-index-js","50":"component---src-pages-summer-camp-js","51":"component---src-pages-summer-camp-junior-day-camp-js","52":"component---src-pages-summer-camp-overnight-camp-hockey-camps-js","53":"component---src-pages-summer-camp-overnight-camp-horse-camps-js","54":"component---src-pages-summer-camp-overnight-camp-js","55":"component---src-pages-summer-camp-overnight-camp-wham-camp-js","56":"component---src-pages-summer-camp-ultimate-day-camp-hockey-camps-js","57":"component---src-pages-summer-camp-ultimate-day-camp-horse-camps-js","58":"component---src-pages-summer-camp-ultimate-day-camp-js","59":"component---src-pages-summer-camp-ultimate-day-camp-wham-camp-js","60":"component---src-pages-teen-ranch-statement-of-faith-js","61":"component---src-pages-terms-and-conditions-js"}[chunkId]||chunkId) + "-" + {"0":"60315f64d8c49defa917","1":"29147cbc04bbc833f6a0","2":"f52c8a944af07ee5cce8","3":"0fdb89d859c22b09fe27","6":"17fa762cd453e0ba0279","7":"557d21496fb76d71943a","8":"58a74c843898d6a353a3","9":"00ba63ad1cf108e73bc5","10":"9842a3be6f05aed1ace2","11":"30d52fedbd38a287ca75","12":"bd512f3d30cece2b99ad","13":"ee4375b62f1eac9dfb04","14":"ef65bf524196afedd677","15":"b52d7e6dbb0557419f32","16":"eede3986565f61438143","17":"95fde0c3f0c82372e5ef","18":"cf1f5edafc8132bea260","19":"217cea599607bc2d745e","20":"22863aa0e943e171efce","21":"9b52fed8d9e1a8aa7c85","22":"8e20a513153174d75e3d","23":"6b9117c05c08aa7b3ac1","24":"21edc73fbbce0afdfd1d","25":"0c480b4f74d7f32b4b57","26":"4e8936b8a4f48e496035","27":"808aa7993b1441e6d9f5","28":"8ab62e7575f4f417a772","29":"c0815da5e95819806ad9","30":"7838e36875136b8f31ee","31":"c069d8c230f18ee8cdc6","32":"a523cecf1a75c0bf02ca","33":"91417847bd3573e3dd0a","34":"20f7738270f85731251c","35":"c10744a855f2a8be7946","36":"557200dc76f3aca71897","37":"4361aa4e91e78e943061","38":"d4f2e98ddb8a548e0d19","39":"43b0a7ed121a066deef3","40":"b5f37a64acc1c45ad315","41":"9f4c187309055fbbe42b","42":"45022b58a7eca25e6b1c","43":"47c34b3dd587901d4a9f","44":"9f28eb7b103cebbb45e9","45":"b8c3e3762f366e5fac62","46":"5eae51789a3391ea2397","47":"ac56a6d18f66651cfe0b","48":"4a26dbe455f2e97b72c2","49":"f825f349467a7a206bf6","50":"4a3f5706e430320936af","51":"48181e413b963a5a7d9d","52":"66f771b1ac7d8814cb27","53":"7128194bf3154f17c045","54":"dcb1d7ce6d52cc858e69","55":"92ddaeeb4be164e120be","56":"982cef9ffb0f46527de5","57":"8790213f2f0aacd73037","58":"35842564788f1ce26370","59":"51a8f084c03bba6fad2a","60":"9d0e25856891b17691f7","61":"f4479d0269996e87689a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"styles","2":"0f1ac474","3":"5b74f8667f3a7f27ab8185c7fc08a7f63be63316","6":"component---src-pages-404-js","7":"component---src-pages-contact-index-js","8":"component---src-pages-day-camp-christmas-day-camp-js","9":"component---src-pages-day-camp-march-break-day-camp-js","10":"component---src-pages-day-camp-pd-pa-day-camp-js","11":"component---src-pages-events-1980-s-staff-reunion-js","12":"component---src-pages-events-christmas-at-the-ranch-js","13":"component---src-pages-events-easter-roundup-js","14":"component---src-pages-events-family-day-roundup-js","15":"component---src-pages-events-family-winter-activity-adventure-js","16":"component---src-pages-events-march-break-camp-for-a-weekend-js","17":"component---src-pages-events-teen-ranch-fall-gallop-a-cross-country-run-js","18":"component---src-pages-events-the-christmas-winter-festival-js","19":"component---src-pages-facilities-js","20":"component---src-pages-families-family-getaway-weekends-js","21":"component---src-pages-families-father-son-hockey-weekend-js","22":"component---src-pages-families-js","23":"component---src-pages-families-mother-daughter-equine-escape-js","24":"component---src-pages-give-index-js","25":"component---src-pages-in-memory-of-mel-stevens-js","26":"component---src-pages-index-js","27":"component---src-pages-outdoor-education-js","28":"component---src-pages-programs-hockey-and-skating-3-on-3-hockey-league-js","29":"component---src-pages-programs-hockey-and-skating-adult-hockey-skills-js","30":"component---src-pages-programs-hockey-and-skating-afternoon-summer-skills-clinics-js","31":"component---src-pages-programs-hockey-and-skating-goalie-clinic-js","32":"component---src-pages-programs-hockey-and-skating-ice-rental-js","33":"component---src-pages-programs-hockey-and-skating-index-js","34":"component---src-pages-programs-hockey-and-skating-learn-to-skate-js","35":"component---src-pages-programs-hockey-and-skating-mens-hockey-league-js","36":"component---src-pages-programs-hockey-and-skating-private-lessons-js","37":"component---src-pages-programs-hockey-and-skating-public-skating-js","38":"component---src-pages-programs-hockey-and-skating-skills-and-skating-development-js","39":"component---src-pages-programs-hockey-and-skating-spring-hockey-league-js","40":"component---src-pages-programs-hockey-and-skating-starskate-and-competitive-figure-skating-js","41":"component---src-pages-programs-hockey-and-skating-wranglers-hockey-js","42":"component---src-pages-programs-horses-hunter-jumper-shows-index-js","43":"component---src-pages-programs-horses-hunter-jumper-shows-show-photos-js","44":"component---src-pages-programs-horses-index-js","45":"component---src-pages-programs-horses-schooling-ring-rental-js","46":"component---src-pages-programs-horses-trail-rides-js","47":"component---src-pages-programs-index-js","48":"component---src-pages-retreats-index-js","49":"component---src-pages-staff-index-js","50":"component---src-pages-summer-camp-js","51":"component---src-pages-summer-camp-junior-day-camp-js","52":"component---src-pages-summer-camp-overnight-camp-hockey-camps-js","53":"component---src-pages-summer-camp-overnight-camp-horse-camps-js","54":"component---src-pages-summer-camp-overnight-camp-js","55":"component---src-pages-summer-camp-overnight-camp-wham-camp-js","56":"component---src-pages-summer-camp-ultimate-day-camp-hockey-camps-js","57":"component---src-pages-summer-camp-ultimate-day-camp-horse-camps-js","58":"component---src-pages-summer-camp-ultimate-day-camp-js","59":"component---src-pages-summer-camp-ultimate-day-camp-wham-camp-js","60":"component---src-pages-teen-ranch-statement-of-faith-js","61":"component---src-pages-terms-and-conditions-js"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"77b6846d73c4497a0f4c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
